import { createContext } from 'react';
export const MultiCheckContext = createContext({});